import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import resize from '@/mixins/resize';
import * as echarts from 'echarts';
import moment from 'moment';
let myChart0 = null;
let myChart1 = null;
let myChart2 = null;
let myChart3 = null;
let myChart4 = null;
import { mapState } from 'vuex';
export default {
  name: 'moreLine',
  mixins: [resize],
  props: ['panelData', 'sort', 'itemNum'],
  data() {
    return {
      sourceX: ['10-1', '10-2', '10-3', '10-4', '10-5', '10-6', '10-7'],
      colorList: [{
        color: '#F6D06F',
        shadowColor: 'rgba(246,208,111, 0.85)'
      }, {
        color: '#5171fd',
        shadowColor: 'rgba(66,102,247, 0.55)'
      }],
      source: [{
        name: '保险1',
        data: [32, 34, 39, 35, 38, 36, 34]
      }, {
        name: '保险2',
        data: [25, 22, 26, 28, 27, 26, 23]
      }]
    };
  },
  computed: {
    ...mapState({
      locale: state => state.setting.locale
    })
  },
  beforeDestroy() {
    // if (myChart != null) {
    //   console.log(44);
    //   myChart.dispose();
    // }
    if (this.itemNum == 0) {
      myChart0 && myChart0.clear();
    } else if (this.itemNum == 1) {
      myChart1 && myChart1.clear();
    } else if (this.itemNum == 2) {
      myChart2 && myChart2.clear();
    } else if (this.itemNum == 3) {
      myChart3 && myChart3.clear();
    } else if (this.itemNum == 4) {
      myChart4 && myChart4.clear();
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.itemNum == 0) {
        myChart0 = echarts.init(this.$refs.moreLine);
      } else if (this.itemNum == 1) {
        myChart1 = echarts.init(this.$refs.moreLine);
      } else if (this.itemNum == 2) {
        myChart2 = echarts.init(this.$refs.moreLine);
      } else if (this.itemNum == 3) {
        myChart3 = echarts.init(this.$refs.moreLine);
      } else if (this.itemNum == 4) {
        myChart4 = echarts.init(this.$refs.moreLine);
      }
      this.initEchart();
    });
  },
  watch: {
    locale: {
      handler(newVal) {
        this.$nextTick(() => {
          this.initEchart();
        });
      }
    },
    panelData: {
      handler() {
        if (this.itemNum == 0) {
          myChart0 && myChart0.clear();
          myChart0 = echarts.init(this.$refs.moreLine);
        } else if (this.itemNum == 1) {
          myChart1 && myChart1.clear();
          myChart1 = echarts.init(this.$refs.moreLine);
        } else if (this.itemNum == 2) {
          myChart2 && myChart2.clear();
          myChart2 = echarts.init(this.$refs.moreLine);
        } else if (this.itemNum == 3) {
          myChart3 && myChart3.clear();
          myChart3 = echarts.init(this.$refs.moreLine);
        } else if (this.itemNum == 4) {
          myChart4 && myChart4.clear();
          myChart4 = echarts.init(this.$refs.moreLine);
        }
        this.$nextTick(() => {
          this.initEchart();
        });
      }
    },
    deep: true
  },
  methods: {
    initEchart() {
      if (this.panelData) {
        this.sourceX = this.panelData.sourceX.map(item => {
          return moment(item, 'YYYY-MM-DD', true).isValid() ? moment(item).format(this.getFormatDate()) : item;
        });
        this.source = this.panelData.source;
      }
      let series = [];
      let that = this;
      this.source.map((item, index) => {
        let obj = {
          name: this.$t(item.name),
          type: 'line',
          data: item.data,
          smooth: true,
          symbol: 'circle',
          showSymbol: true
        };
        series.push(obj);
      });
      const option = {
        tooltip: {
          trigger: 'axis',
          confine: true,
          appendToBody: true,
          axisPointer: {
            type: 'cross'
          },
          orient: 'vertical',
          // extraCssText:'max-width:1200px;',
          formatter: function (params) {
            if (params instanceof Array) {
              let str = '',
                arr = [];
              str += `<div style="margin-left: 5px;">${params[0].axisValue}</div>`;
              params.forEach((m, index) => {
                if (m.data != 0) {
                  arr.push(m);
                }
              });
              if (arr.length == 0) {
                str += that.$t('暂无数据');
              } else {
                let num = 550;
                if (arr.length == 1) {
                  num = 275;
                }
                str += `<div style="display:flex;flex-wrap: wrap;width:${num}px">`;
                arr.forEach((m, index) => {
                  str += `
                     <div style="display: flex;width:275px;align-items:baseline;font-size:10px">
                       <div style="width: 8px;height: 8px;display: inline-block;background: ${m.color};border-radius: 10px;margin-right: 5px;margin-left: 5px; "></div>
                       <div style="display:flex;align-items: baseline;flex:1;overflow: hidden;margin-right: 5px;">
                        <div style="max-width: 100%;
                          word-break: break-all;
                          text-overflow: ellipsis;
                          white-space:pre-wrap;
                          overflow: hidden;
                          display: -webkit-box;
                          -webkit-box-orient: vertical;
                          -webkit-line-clamp: 2;">${m.seriesName}:<span> ${m.data}</span></div></div>
                     </div>
                     `;
                });
                str += `</div>`;
              }
              return str;
            }
          },
          position: function (point, params, dom, rect, size) {
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置
            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];
            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];
            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = -(pointX + 10);
            } else {
              // 左边放的下
              x = pointX - boxWidth - 10;
            }
            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else {
              // 上边放得下
              y = pointY - boxHeight;
            }
            return [x, y];
          }
        },
        grid: {
          left: 80,
          right: 50,
          bottom: 40,
          top: 85
        },
        legend: {
          show: true,
          type: 'scroll'
        },
        xAxis: [{
          type: 'category',
          boundaryGap: false,
          data: that.sourceX,
          axisLine: {
            lineStyle: {
              color: '#cecece'
            }
          },
          axisLabel: {
            color: '#666'
          },
          axisTick: {
            show: false
          },
          axisPointer: {
            snap: true
          }
        }],
        yAxis: [{
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#cecece'
            }
          },
          axisLabel: {
            color: '#666'
          },
          splitLine: {
            show: false
          },
          axisPointer: {
            snap: true
          }
        }],
        series: series
      };
      if (this.itemNum == 0) {
        myChart0.setOption(option, true);
      } else if (this.itemNum == 1) {
        myChart1.setOption(option, true);
      } else if (this.itemNum == 2) {
        myChart2.setOption(option, true);
      } else if (this.itemNum == 3) {
        myChart3.setOption(option, true);
      } else if (this.itemNum == 4) {
        myChart4.setOption(option, true);
      }
    }
  }
};